module.exports = __webpack_public_path__ + "static/zqb_2.3ecd3cd0.png";